import axios from "axios";
import { BASE_URL, SUB_URL } from "./BaseUrl";

const DashboardService = {

  getDashboardData: async (selectArea, userData) => {

    try {
      const formData = new FormData();
      formData.append("user_id", userData.su_id);
      formData.append("line_no", selectArea);

      const response = await axios.post(
        `${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL.get_dashboard_data}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Response Data:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      return [];
    }
  },

  getLine: async () => {
    try {
      const response = await axios.get(`${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL.getLine}`);
      console.log("Response Data:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching Line:", error);
      return [];
    }
  },
};

export default DashboardService;
